export const SECTION_PADDING = '2.125rem 2rem';

export const TWITTER = 'twitter';

export const ABOVE_TIDIO_ZINDEX = 999999999;
